import { render } from "./FavIcon.vue?vue&type=template&id=f972a1e2"
import script from "./FavIcon.vue?vue&type=script&lang=js"
export * from "./FavIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__